import React, { FC, Fragment } from 'react';
import { Button } from '@cokitchen/cokitchen-components';
import { useLocation, useNavigate } from 'react-router-dom';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import { formatRequestDate } from 'utils/functions';
import { RequestType } from 'models/item-request.model';
import { ENUM_REQUEST_STATUS } from 'models/common.model';
import RequestStatusTag from '../request-status-tag';

type Props = {
  procurement: RequestType;
};

const KitchenProcurementCard: FC<Props> = ({ procurement }) => {
  const router = useNavigate();
  const { pathname } = useLocation();
  const updateProcurement = () => {
    let route = '';
    if (pathname.includes(MAIN_STORE_ROUTE_KEYS.KITCHEN_PROCUREMENT)) {
      procurement.status === ENUM_REQUEST_STATUS.REJECTED
        ? (route = `${MAIN_STORE_ROUTE_KEYS.KITCHEN_PROCUREMENT}/update-rejected/${procurement.id}`)
        : (route = `${MAIN_STORE_ROUTE_KEYS.KITCHEN_PROCUREMENT}/update/${procurement.id}`);
    } else {
      route = `${pathname}/${procurement.id}`;
    }

    router(route);
  };

  return (
    <Fragment>
      <div className='border hover:bg-gray-11 border-gray-13 rounded-lg flex flex-col py-2'>
        <div className='grow'>
          <div className='flex border-b border-[#ECEDEF] pb-2 items-center gap-2 flex-wrap justify-between px-3'>
            <h4 className='font-medium text-base cursor-pointer'>#{procurement.code}</h4>
            <RequestStatusTag status={procurement?.status || ENUM_REQUEST_STATUS.PENDING} />
          </div>

          <div className='p-3 '>
            {procurement?.items?.map((item, i) => (
              <div key={i} className='flex items-center '>
                <p className='capitalize text-xs'>{item.ingredient.name}</p>
                <div className='bg-[#DCDBD5] inline-block mx-1 w-[5px] h-[5px] rounded-full' />
                <p className='text-xs text-gray-5'>
                  {item.quantity + ' '}
                  {item.ingredient.unit_type || ' portions'} requested
                </p>
                {item.quantity_sent || item.quantity_received ? (
                  <div className='bg-[#DCDBD5] inline-block mx-1 w-[5px] h-[5px] rounded-full' />
                ) : (
                  ''
                )}
                <p className='text-xs text-gray-5'>
                  {item.quantity_received
                    ? item.quantity_received +
                      ' ' +
                      (item.ingredient.unit_type || ' portions') +
                      ' received'
                    : item.quantity_sent
                    ? item.quantity_sent + ' ' + (item.ingredient.unit_type || 'portions') + ' sent'
                    : ''}{' '}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className='flex border-t border-[#ECEDEF] pb-2 text-xs items-center gap-2 flex-wrap justify-between mx-3 pt-2'>
          <p>{formatRequestDate(procurement.created_at)}</p>
          <Button
            className='text-xs'
            color='primary'
            variant='link'
            onClick={() => updateProcurement()}>
            View
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

export default KitchenProcurementCard;
